import { User } from "../../models/user";

export class SetCurrentUser {
  public static readonly type = "[Users] set current";
  public constructor(public currentUser: User) {}
}
